import { Button, Flex } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../../../../constants/colorConstants";
import { useCalendarContext } from "../../../../contexts/CalendarContext";
import PageHeader from "../../../../shared/components/blocks/PageHeader";

export default function CalendarViewHeader() {
  const { singleFetch } = useCalendarContext();

  return (
    <PageHeader
      title={"Calendar"}
      breadcrumbs={[
        { label: "Calendars", to: "/calendars" },
        { label: singleFetch?.data?.name, to: "#" },
      ]}
      actions={
        <Flex justify="flex-end" align="center" gap="xl">
          <CloseButton />
        </Flex>
      }
    />
  );
}

function CloseButton() {
  const navigate = useNavigate();

  return (
    <Button
      size="sm"
      radius="md"
      bg={COLORS.DARK_BROWN}
      c={COLORS.WHEAT}
      fw={600}
      fz={16}
      onClick={() => navigate("/calendars")}
    >
      Close
    </Button>
  );
}
